<div class="only-mobile">
  <h1 class="h3">{{ title }}</h1>
</div>

<div class="drop-zone-box animated fadeIn">
  <div class="drop-zone-content">
    <div class="welcome-box">
      <p class="welcome-title">
        <img
          src="assets/images/logo/{{ theme }}/logo-signtrust-color.svg"
          class="logo"
          alt="brand_logo"
        />
      </p>

      <p class="welcome-title">{{ 'GLOBAL.WELCOME-TITLE' | translate }}</p>
      <p class="welcome-description">{{ 'GLOBAL.WELCOME-DESCRIPTION' | translate }}</p>
    </div>

    <div
      class="drop-area pointer"
      appDropFile
      (onFileDropped)="onFileUploaded($event, false)"
      (click)="fileDropRef.click()"
    >
      <input
        type="file"
        #fileDropRef
        id="fileDropRef"
        hidden
        accept="application/pdf"
        (change)="onFileUploaded($event.target.files[0], false); $event.target.value = ''"
      />

      <div class="drop-document-icon">
        <i class="rt-icon rt-archivo"></i>
      </div>

      <div class="drop-text">
        <p *ngIf="!isMobile" class="description">{{ 'WEB-SIGN.FILE-UPLOAD.DESCRIPTION-1' | translate }}</p>
        <p *ngIf="!isMobile" class="description-sm between-lines">{{ 'WEB-SIGN.FILE-UPLOAD.DESCRIPTION-2' | translate }}</p>
        <p class="description">{{ 'WEB-SIGN.FILE-UPLOAD.DESCRIPTION-3' | translate }}</p>
      </div>
    </div>
  </div>
</div>

<!-- PDF VIEWER COMPONENT (attached to the DOM as an overlay) -->
<ng-template #signViewTemplate>
  <div class="fadeIn pdf-container">
    <signtrust-pdf-viewer
      [(documentFile)]="documentFile"
      [(page)]="page"
      [(isSp)]="isSharepointDocument"
      (spUploadDocument)="uploadDocument($event)"
      (onClose)="onClosePdfViewer()"
    ></signtrust-pdf-viewer>
  </div>
</ng-template>
